<template>
	<div class="loginbg_picc" v-loading="loadingstatus" element-loading-text="登录中">
	    <div class="login_logo"></div>
		<div class="popup_center">
		  <div class="box_size">
		  <div class="login_img"></div>
		    <div class="login">
		      <div class="user_tab"  style="margin-top: 50px;">
		        <ul>
		          <li class="active" style="width:100%"><a>用户登录</a></li>
		        </ul>
		      </div>
		      <div class="login_input">
		        <ul>
		          <li>
		            <input type="text" placeholder="用户名" v-model="form.id" v-on:keyup.enter="submit">
		          </li>
		          <li>
		            <input type="password" placeholder="密码" v-model="form.password" v-on:keyup.enter="submit">
		          </li>
		        </ul>
		      </div>
		      <div class="login_bot">
		        <!--<p><em><i>&nbsp;</i></em> <a @click="gotoGetPassword">找回密码</a></p>-->
		        <span><a @click="submit">登录</a></span> </div>
		    </div>
		  </div>
		</div>
		<!--<div class="bot_tip">
			<span> <a>联系我们</a> | <a>法律声明</a> | <a>下载中心</a> | <a>网站地图</a></span> 
			<em>©2017 青岛迪迪网络科技有限公司 All Rights Reserved.</em>
		</div>-->
	    <!--页面tab弹框组件开始-->				
		<main-modal ref="modal1" size="small" title="提示" >
			<p v-text="tipContent"></p>	
			<div slot="footer">
				<button class="btn btn-primary" @click="closetip">关闭</button>
			</div>
		</main-modal>
		<!--系统更新组件-->
		<!-- <update-list v-if="showUpdate" v-on:startUse="saveUpdate" :versionInfo="versionInfo"></update-list> -->
	</div>
</template>

<script>
  import { calcuAES } from 'util/aes'
	import {setLocalStore,getLocalStore,removeLocalStore} from 'util/util'
  import MainModal from 'components/common/MainModal'
  import { LOGIN_FAILE, LOGIN_USER_EMPTY, LOGIN_PASSWORD_EMPTY, LOGIN_EXCEPTION,OPERATE_EXCEPTION } from 'static/message'
  import UpdateList from 'components/layouts/UpdateList'
	export default {
		name: 'login',
		components: {
			MainModal
		},
		data() {
			return {
				form: {
					id: '',
					password: ''
				},
				loadingstatus:false,
				tipContent:'',
				showUpdate:false,
				versionInfo:{}
			}
		},
		beforeMount(){
			const param = {
				last:0,
				source:2
			}
			//process.env.API_ROOT + '/noauth/timeline',param
			//'../../../../static/update/update.json'
			this.$http.get(process.env.API_ROOT + '/noauth/timeline',{params:param})
			.then(res=>{
				this.versionInfo = res.body.data
				this.$store.dispatch('getVersion',res.body.data.versionName)
				let version = getLocalStore('version')
				if(version == this.versionInfo.versionName){
					this.showUpdate = false
				}else{
					this.showUpdate = true;
				}
			},res=>{
				this.opentip(res.body.message);
			})
			.catch(res=>{
				this.opentip("请求异常");
			})
			
		},
		mounted() {
//			if (this.$store.state.user.status=="401"){
//				this.opentip("权限认证失败,请重新登录");
//			}
		},
		methods: {
			submit(){
				if(!this.form.id) {
					this.opentip(LOGIN_USER_EMPTY);
					return;
				}
				if(!this.form.password) {
					this.opentip(LOGIN_PASSWORD_EMPTY);
					return;
				}
				let loginuser = {"username":this.form.id,"password":calcuAES(this.form.password)};
				this.loadingstatus=true;
				this.$http.post(process.env.API_ROOT + '/account/login',loginuser) //../../static/login.json
	    		.then((response)=>{
						if(response.body.status===200){
							const {token,customerId,isAdmin,name,diplayPic,userId} = response.body;
							let info = {
								user:this.form.id,
								username:name,
								userimg:diplayPic,
								group:customerId,
								admin:isAdmin,
								token:token,
								userId:userId
							}
							this.$store.dispatch('saveall',info);
							this.$router.push("indexhome");
							this.startTimerToken();
							this.loadingstatus=false;
						}else{
							this.loadingstatus=false;
							this.opentip(response.body.message);
						}
						
					},(response)=>{
						this.loadingstatus=false;
						this.opentip(response.body.message);
					})
	    		.catch((response)=>{
	    			this.loadingstatus=false;
					this.opentip(LOGIN_EXCEPTION);
				})
			},
			closetip(){
				this.$refs.modal1.close();	
			},
			opentip(message){
				this.tipContent=message;
				this.$refs.modal1.open();	
			},
			gotoGetPassword(){
				this.$router.push("getpassword");
			},
			//开启定时
			startTimerToken(){
			//	let tokenTimer = setInterval(this.getToken,10000)
				let tokenTimer = setInterval(this.getToken,35 * 60 * 60 * 1000);
				this.$store.dispatch('savetokentimer', tokenTimer)
			},
			//拉取token
			getToken(){
				this.$http.post(process.env.API_ROOT + '/account/keep-token')
				.then(res => {
					if(res.body.success){
						this.setToken(res.body.data);
					}
				}, res => {
					this.opentip(res.body.message);
				}).catch( res => {
					this.opentip('请求异常');
				})	
			},
			//设置token
			setToken(token){
				if (token!==this.$store.state.user.accesstoken){
					this.$store.dispatch('settoken', token);
				}
			},
			//添加到本地存储
			saveUpdate(bool){
				this.showUpdate = false;
				if(bool){
					setLocalStore('version',this.versionInfo.versionName)
				}
			}
		}
	}
</script>


// WEBPACK FOOTER //
// Login.vue?2ac3a52e